import axios from 'axios'
import { getAuth } from 'firebase/auth'

type UserActivitySuccess = any // Replace `any` with the proper shape if known
type UserActivityFailure = {
  app_user_id: string
  status: number
  message: string
}

type GetUserActivityResponse = {
  message: string
  success: UserActivitySuccess[]
  failed: UserActivityFailure[]
}

export async function fetchUserActivity(
  appUserIds: string[],
): Promise<GetUserActivityResponse> {
  //console.log("Fetching user activity for appUserIds:", appUserIds);
  if (!Array.isArray(appUserIds) || appUserIds.length === 0) {
    throw new Error('appUserIds must be a non-empty array')
  }

  try {
    // Get the current user's token directly from Firebase Auth
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('User not authenticated');
    }
    
    // Get fresh token (Firebase automatically refreshes if needed)
    const token = await user.getIdToken();
    const response = await axios.post<GetUserActivityResponse>(
      'https://getuseractivity-c5yieuvjca-uc.a.run.app',
      // "http://127.0.0.1:5001/elisyanwealth/us-central1/getUserActivity", // 🔁 Replace this
      { app_user_ids: appUserIds },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )
    // console.log("User activity response from revenueCatApis fetch function:", response.data);
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = error.response?.data?.message || error.message
      console.error('Axios error:', message)
      throw new Error(message)
    } else {
      console.error('Unexpected error:', error)
      throw new Error('Unexpected error')
    }
  }
}

export async function fetchUserSubscriptions(
  appUserIds: string[],
): Promise<any> {
  //console.log("Fetching user activity for appUserIds:", appUserIds);
  if (!Array.isArray(appUserIds) || appUserIds.length === 0) {
    throw new Error('appUserIds must be a non-empty array')
  }

  try {
    const response = await axios.get(
      `https://api.revenuecat.com/v2/projects/customers/${appUserIds[0]}/subscriptions`,
      // "http://127.0.0.1:5001/elisyanwealth/us-central1/getUserActivity", // 🔁 Replace this
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer `,
        },
      },
    )
    // console.log("User activity response from revenueCatApis fetch function:", response.data);
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = error.response?.data?.message || error.message
      console.error('Axios error:', message)
      throw new Error(message)
    } else {
      console.error('Unexpected error:', error)
      throw new Error('Unexpected error')
    }
  }
}
